import { render } from "./MyUser.vue?vue&type=template&id=2c3f9c3f"
import script from "./MyUser.vue?vue&type=script&lang=js"
export * from "./MyUser.vue?vue&type=script&lang=js"

import "./MyUser.vue?vue&type=style&index=0&id=2c3f9c3f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__